export const eventBus = new EventTarget()

const FilterSelectedEvent = 'FilterSelected'

const CallLoadingEvent = 'CallLoading'

export function RegistLoading(func) {
  eventBus.addEventListener(CallLoadingEvent, (event) => {
    func(event.detail)
  })
}
export function triggerCallLoading(bLoading) {
  eventBus.dispatchEvent(new CustomEvent(CallLoadingEvent, { detail: bLoading }))
}